import React from "react";
import { Title } from "../Typography";
import { makeStyles } from "@material-ui/styles";
import Question from "./Question";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  },
  container: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      alignItems: "center",
      minHeight: "273px",
      backgroundColor: theme.palette.background.light,
      padding: theme.spacing(1)
    },
  },
  text: {
    overflowWrap: "break-word",
    textAlign: "left",
    whiteSpace: "pre-wrap",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
      textAlign: "center",
      backgroundColor: theme.palette.primary.light,
      margin: "auto"
    },
  },
}));

const DocumentUploadStep = ({ message, description, question, onSubmit }) => {
  const classes = useStyles();

  return (
    <Box>
      <Box className={classes.title}>
        <Title text={message} />
      </Box>

      <Box className={classes.container}>
        <Question key={question.key} question={question} onSubmit={onSubmit} />
      </Box>
    </Box>
  );
};

export default DocumentUploadStep;
